import script from "./InputMoney.vue?vue&type=script&setup=true&lang=js"
export * from "./InputMoney.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__